import getJsSDKConfig from "@/api/common/we-chat/getJsSDKConfig";
import wx from "weixin-js-interface";
import {mapGetters} from "vuex";
import {Loading, Message} from "element-ui";

export default {
    data() {
        return {
            getBrandWCPayRequest: {
                appId: undefined,
                timestamp: undefined,
                nonceStr: undefined,
                package: undefined,
                signType: undefined,
                paySign: undefined,
                nonceStr1: undefined,
                paySign1: undefined,
            }
        }
    },
    computed: {
        ...mapGetters({
            device: 'device',
        }),
    },
    methods: {
        scan({callBack}) {
            if (this.device === 'desktop') {
                Message({
                    message: "请在微信中使用此功能",
                    type: 'error',
                    duration: 3 * 1000
                });
            } else {
                let loadingInstance = Loading.service({text: "加载中"});
                getJsSDKConfig().then(res => {
                    wx.config({
                        debug: process.env.VUE_APP_DEBUG !== 'false',
                        appId: res.data.appId,
                        timestamp: res.data.timeStamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: ['scanQRCode']
                    });
                    wx.ready(() => {
                        wx.scanQRCode({
                            needResult: 1,
                            scanType: ["qrCode", "barCode"],
                            success: function (res) {
                                if (typeof callBack === "function") {
                                    callBack(res)
                                }
                                loadingInstance.close();
                            },
                            cancel: function () {
                                loadingInstance.close();
                            },
                            error: function (res) {
                                loadingInstance.close();
                                if (res.errMsg.indexOf('function_not_exist') > 0) {
                                    alert('版本过低请升级')
                                }
                            }
                        });
                    });
                    wx.error(() => {
                        loadingInstance.close();
                    });
                });
            }
        },
    },
}